"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const line_reader_1 = __importDefault(require("line-reader"));
const eachLine = (fileName, eachLineCallBack, filter) => {
    let lineIndex = 0;
    return new Promise((resolve, reject) => {
        line_reader_1.default.eachLine(fileName, function (line) {
            if (filter && filter(line))
                return true;
            lineIndex += 1;
            return eachLineCallBack(line, lineIndex);
        }, function (err) {
            if (err)
                reject(err);
            resolve(fileName);
        });
    });
};
exports.default = eachLine;
